import { render, staticRenderFns } from "./GoodsUseDetail.vue?vue&type=template&id=6633d9b5&scoped=true&"
import script from "./GoodsUseDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsUseDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsUseDetail.vue?vue&type=style&index=0&id=6633d9b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633d9b5",
  null
  
)

export default component.exports